import { render, staticRenderFns } from "./PaymentMethod.view.vue?vue&type=template&id=13b000a0&scoped=true"
import script from "./PaymentMethod.view.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.view.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethod.view.vue?vue&type=style&index=0&id=13b000a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b000a0",
  null
  
)

export default component.exports